import React from "react";

import { Box, Text } from "@chakra-ui/react";

interface IProps {
  tagColor?: string;
  nameOnTag?: string;
}
const ProductTagNameTopRight = ({
  tagColor = "secondary",
  nameOnTag = "",
}: IProps) => {
  return (
    <Box
      position="absolute"
      top={0}
      right={0}
      w={0}
      h={0}
      borderWidth="0 5rem 5rem 0"
      borderRightColor={tagColor}
      borderBottomColor={"transparent"}
      borderTopRightRadius={"md"}
      textAlign="center"
      color="white"
      fontSize="sm"
    >
      <Text
        textStyle={"h6"}
        textTransform={"uppercase"}
        fontWeight={800}
        style={{
          position: "absolute",
          transform: "rotate(45deg)",
          width: "60px",
          height: "100px",
        }}
      >
        {nameOnTag}
      </Text>
    </Box>
  );
};

export default ProductTagNameTopRight;
